// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    max-width: 400px;
    margin: 40px auto;
    font-family: Arial, sans-serif;
  }
  
  .task {
    border: 1px solid #ccc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .task-button {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    font-size: 16px;
    /*font-weight: bold;*/
    background-color: #f0f0f0;
    border: none;
    cursor: pointer;
    transition: background 0.3s;
    border-radius: 8px 8px 0 0;
  }
  
  .task-button:hover {
    background-color: #e0e0e0;
  }
  
  /* Chevron Styling */
  .chevron {
    font-size: 14px;
    margin-left: 8px;
  }
  
  .chat-list {
    padding: 10px;
    border-top: 1px solid #ddd;
    background: #fff;
  }
  
  .chat-item {
    padding: 8px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: background 0.2s;
  }
  
  .chat-item:last-child {
    border-bottom: none;
  }
  
  .chat-item:hover {
    background-color: #f9f9f9;
  }
  `, "",{"version":3,"sources":["webpack://./src/chat/task/TaskChatPanel.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,oBAAoB;EACpB;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".container {\n    max-width: 400px;\n    margin: 40px auto;\n    font-family: Arial, sans-serif;\n  }\n  \n  .task {\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    margin-bottom: 10px;\n    background-color: #fff;\n    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .task-button {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    font-size: 16px;\n    /*font-weight: bold;*/\n    background-color: #f0f0f0;\n    border: none;\n    cursor: pointer;\n    transition: background 0.3s;\n    border-radius: 8px 8px 0 0;\n  }\n  \n  .task-button:hover {\n    background-color: #e0e0e0;\n  }\n  \n  /* Chevron Styling */\n  .chevron {\n    font-size: 14px;\n    margin-left: 8px;\n  }\n  \n  .chat-list {\n    padding: 10px;\n    border-top: 1px solid #ddd;\n    background: #fff;\n  }\n  \n  .chat-item {\n    padding: 8px;\n    border-bottom: 1px solid #eee;\n    cursor: pointer;\n    transition: background 0.2s;\n  }\n  \n  .chat-item:last-child {\n    border-bottom: none;\n  }\n  \n  .chat-item:hover {\n    background-color: #f9f9f9;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
